import { css } from "styled-components";

export const stopPropagation = (event: React.SyntheticEvent): void =>
  event.stopPropagation();

export const itemFocusStyles = css`
  position: relative;

  /* focus ring that won't get cutoff by hidden overflow */
  ::after {
    content: "";
    pointer-events: none;
    position: absolute;
    inset: 0;
    border-radius: ${({ theme }) => theme.borderRadius};
  }
  &:focus-visible::after {
    /* not [data-focus-visible="true"] because that's also applied when
    the user clicks on the item, and then navigates to an inner widget */
    box-shadow: ${({ theme }) => theme.boxShadow.INPUT_FOCUS};
  }
  &:focus-visible,
  &:focus {
    outline: none;
  }
  &:active:not(:focus-within) {
    background-color: ${({ theme }) => theme.activeColor};
  }

  /* not on pointer focus */
  &:focus:not(:focus-visible)::after {
    box-shadow: none;
  }
`;
